import { AxiosError } from 'axios';

export const getAxiosExceptionMessage = (
  error: AxiosError | Error | unknown,
  defaultMessage: string = 'Something went wrong'
) => {
  console.log(error);
  if (
    error instanceof AxiosError &&
    (error?.response?.data?.message || error?.response?.data?.error)
  ) {
    return error?.response?.data?.message || error.response.data.error;
  }
  if (error instanceof Error && error?.message) {
    return error.message;
  }
  return defaultMessage;
};

export const sortSelectedOptionsFirst = <Option, Value>(
  options: Option[] = [],
  selectedValues: Value[] = [],
  getOptionValue: (_option: Option) => Value
) => {
  return [...options].sort((firstOption, secondOption) => {
    const isFirstSelected = selectedValues.includes(
      getOptionValue(firstOption)
    );
    const isSecondSelected = selectedValues.includes(
      getOptionValue(secondOption)
    );

    if (isFirstSelected === isSecondSelected) {
      return 0;
    }

    return isFirstSelected ? -1 : 1;
  });
};
